import { render } from "./DHSchemaNode.vue?vue&type=template&id=c0ae7c66&scoped=true"
import script from "./DHSchemaNode.vue?vue&type=script&lang=js"
export * from "./DHSchemaNode.vue?vue&type=script&lang=js"

import "./DHSchemaNode.vue?vue&type=style&index=0&id=c0ae7c66&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0ae7c66"]])

export default __exports__